/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "close",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "none",
                "stroke": "#666666",
                "strokeWidth": "2",
                "strokeLinecap": "round",
                "strokeLinejoin": "round",
                "strokeMiterlimit": "10"
            },
            "st1": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "none",
                "stroke": "#666666",
                "strokeLinecap": "square",
                "strokeLinejoin": "round",
                "strokeMiterlimit": "10"
            },
            "close": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "31",
            "height": "31"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31 31", className: "close", width: this.props.width, height: this.props.height, style: this.props.close },
            _react2["default"].createElement("path", { className: "st0", d: "M8.4 8.2l14.1 14.2M8.3 23L22.7 8.4", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st1", d: "M.5 15.5c0-8.3 6.7-15 15-15s15 6.7 15 15-6.7 15-15 15-15-6.7-15-15z", style: this.props.st1 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/close.js